import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const cardAccents = [
  'bg-primary-50',
  'bg-accent-50',
  'bg-secondary-50',
  'bg-background-200',
];

export default function LatestNews() {
  const latestArticles = articles.slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="mb-8 md:mb-10">
        <span className="inline-block text-xs font-bold uppercase tracking-wider text-accent-600 bg-accent-50 px-3 py-1 rounded-full">
          /最新八卦
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
          最新资讯
          <span className="block font-body text-lg md:text-xl italic text-foreground-400 font-light mt-1">
            实时追踪，永不掉队
          </span>
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latestArticles.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="rounded-lg overflow-hidden bg-background-50 group cursor-pointer transition-all duration-300 hover:-translate-y-1"
          >
            <div className={`relative h-48 md:h-56 ${cardAccents[index % 4]}`}>
              <div className="absolute inset-0 flex items-center justify-center p-6">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              {article.isHot && (
                <span className="absolute top-3 left-3 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                  热
                </span>
              )}
            </div>
            <div className="p-4">
              <span className="text-xs text-accent-600 font-medium">{article.category}</span>
              <h3 className="mt-2 text-sm md:text-base font-bold text-foreground-900 leading-snug line-clamp-2">
                {article.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {article.commentCount}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}